import _ from 'lodash'
import $ from 'jquery'
import * as chartColors from 'scoreboard/charts/config/chart-colors'
import Constants from '../constants'
const { RICH_TEXT_COLOR_PREFIX } = Constants

// Must parallel sass/variables/text.scss
const sizes =
	[ 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72, 96 ]

/**
 * Returns the rich text colors in "raw" format. For example, 'blue-dark' instead
 * of 'rich-text-color-blue-dark'.
 *
 * Note that this is a function instead of a constant, because it uses the
 * 'chart-colors' module, and its data isn't available until the globals XHR
 * is complete
 */
function rawColors() {
	// Rich text colors are nearly identical to chart colors, so start from there
	let colors = chartColors.grouped()

	// add in 'gray-darker' right before 'gray-dark', which is the 4th element in the
	// last group
	let lastGroup = colors[colors.length-1]
	lastGroup.splice(3, 0, 'gray-darker')

	// Now that last group is too long, so push the last color ('gray-light')
	// into a new group with 'white'
	let lastColor = lastGroup.splice(-1)[0]
	colors.push([ lastColor, 'white' ])

	return colors
}

/**
 * Returns the rich text colors in their CSS class name format. For example,
 * 'rich-text-color-blue-dark' instead of 'blue-dark'
 *
 * See rawColors() for explanation of why this is a function instead of a constant
 */
function richTextColors () {
	return _.map(rawColors(), function (group) {
		return _.map(group, function (color) { return RICH_TEXT_COLOR_PREFIX + color })
	})
}

function rgbToColorClass (rgb) {
	initColorMaps()
	return colorByRgb[rgb]
}

function hexToColorClass (hex) {
	initColorMaps()
	return colorByHex[hex]
}

var colorByHex
var colorByRgb
function initColorMaps () {
	if (!colorByRgb) {
		colorByRgb = {}
		colorByHex = {}
		_(colors()).flatten().forEach(function (clazz) {
			var test = $('<span class="is-not-displayed ' + clazz + '"></span>').appendTo(document.body)
			var rgb = test.css('color')
			test.remove()

			colorByRgb[rgb] = clazz
			colorByHex[rgbToHex(rgb)] = clazz
		})
	}
}

function rgbToHex(rgb) {
	// regex parses values like 'rbg (14, 32, 99)' into [14, 32, 99]
	var parts = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
	delete(parts[0])
	for (var i = 1; i <= 3; ++i) {
		parts[i] = parseInt(parts[i]).toString(16)
		if (parts[i].length == 1) parts[i] = '0' + parts[i]
	}
	return '#' + parts.join('')
}

export { rawColors, richTextColors, rgbToColorClass, hexToColorClass, sizes }